import axios from "axios";
import type { LegacyResponse } from "@/shared/utils/LegacyResponse.ts";
import type { IndicatorsGroupOut } from "@/pages/human-resources/time-management/endpoints/indicators/inout/IndicatorsGroupOut.ts";

export async function getIndicatorsGroups(
  siteId: string,
): Promise<IndicatorsGroupOut[]> {
  const {
    data: {
      body: { descriptors },
    },
  } = await axios.get<LegacyResponse>("/rest/rh/temps/indicators/descriptors", {
    params: { idSite: siteId },
  });
  return (descriptors ?? []) as IndicatorsGroupOut[];
}
